import common from "./common.json";
import menu from "./menu.json";
import journal from "./journals.json";
import plans from "./plans.json";
import rup from "./rup.json";
import textEditor from './textEditor.json'

//entrant
import register from './entrant/register.json'
import admission from './entrant/admission.json'
import executorAdmissionSteps from './entrant/executorAdmissionSteps.json'
import admissionView from './entrant/admissionView.json'
import admissionNotes from './entrant/admissionNotes.json'
import educationOrders from './entrant/educationOrders.json'
import breadcrumbs from './entrant/breadcrumbs.json'


export default {
  common,
  menu,
  journal,
  plans,
  rup,
  register,
  admission,
  executorAdmissionSteps,
  admissionView,
  admissionNotes,
  educationOrders,
  breadcrumbs,
  textEditor
};
